/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateWorkflowOwnershipRequest
 */
export interface ValidateWorkflowOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateWorkflowOwnershipRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateWorkflowOwnershipRequest
     */
    validationCode: string;
}

/**
 * Check if a given object implements the ValidateWorkflowOwnershipRequest interface.
 */
export function instanceOfValidateWorkflowOwnershipRequest(value: object): value is ValidateWorkflowOwnershipRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('validationCode' in value) || value['validationCode'] === undefined) return false;
    return true;
}

export function ValidateWorkflowOwnershipRequestFromJSON(json: any): ValidateWorkflowOwnershipRequest {
    return ValidateWorkflowOwnershipRequestFromJSONTyped(json, false);
}

export function ValidateWorkflowOwnershipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateWorkflowOwnershipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'validationCode': json['validationCode'],
    };
}

export function ValidateWorkflowOwnershipRequestToJSON(value?: ValidateWorkflowOwnershipRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'validationCode': value['validationCode'],
    };
}

